import axios from 'axios'
import {
    Notification,
    MessageBox,
    Message
} from 'element-ui'
import store from '@/store'
import router from '@/router';
import errorCode from '@/utils/errorCode'
// import Cookies from 'js-cookie'
axios.defaults.withCredentials = true //让Ajax携带cookie
// axios.defaults.headers['Content-Type'] = 'text/plain'
// axios.defaults.headers['Cookie'] = 'ybRg88NKF7JNRGgztnONKkHj36aoyvezpvCKk004'
// console.log(Cookies.get("Admin-Token"))
//	var url = "http://124.70.68.85:8080/aaes/";

// const BASE_URL = 'http://43.135.178.170:8080/'
const BASE_URL = 'https://api.networkvape.com/'
// const BASE_URL = 'https://502m07869l.zicp.fun/'
// http://api.networkvape.com/
// 创建axios实例
const request = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    // http://tianyue.test.hbbright.cn/
    // http://manage.tyxbk.com
    // http://43.135.178.170:8080
    baseURL: BASE_URL, //线上
    // baseURL: process.env.NODE_ENV === 'production' ? 'http://tianyue.swimafish.com/' : '', //线上
    withCredentials: false,
    // 超时
    timeout: 1000000,
})

var token = '';
request.interceptors.request.use(config => {
    token = localStorage.getItem('TIANYUE_TOKEN')
    if (token) config.headers.Authorization = 'Bearer ' + token;
    return config;
})

// 响应拦截器
request.interceptors.response.use(
    (res) => {
        // 未设置状态码则默认succeed状态
        const code = res.data.code || 200
        // 获取错误信息
        const msg = errorCode[code] || res.data.msg || errorCode['default']
        if (code === 200) {
            return res.data
        } else if (code === 401) {
            // TODO
            // MessageBox.confirm(
            //     'The login status has expired, you can stay on the page or log in again',
            //     'system prompt', {
            //         confirmButtonText: 'log in again',
            //         cancelButtonText: 'cancel',
            //         type: 'warning',
            //     }
            // ).then(() => {
            //     location.href = 'https://www.networkvape.com/#/'
            // })
            router.replace("/login")
            // location.href = location.origin+'/#/login'
            // location.href = 'https://www.networkvape.com/#/'
        } else if (code === 500) {
            Message({
                message: msg,
                type: 'error',
            })
            return Promise.reject(new Error(msg))
        } else {
            Notification.error({
                title: msg,
            })
            return Promise.reject('error')
        }
    },
    (error) => {
        console.log(error.response.data)
        let {
            message
        } = error
        // if (message == 'Network Error') {
        //     message = '后端接口连接异常'
        // } else if (message.includes('timeout')) {
        //     message = '系统接口请求超时'
        // } else if (message.includes('Request failed with status code')) {
        //     message = '系统接口' + message.substr(message.length - 3) + '异常'
        // }
        // Message({
        //     message: message,
        //     type: 'error',
        //     duration: 5 * 1000,
        // })
        if (error.response.data.code == 401) {
            Message({
                message: error.response.data.msg,
                type: 'error',
                duration: 1000000,
            })
            // location.href = location.origin+'/#/login'
            router.replace("/login")

        }
        return Promise.reject(error)
    }
)

export {
    request,
    BASE_URL
}